module.exports = __webpack_public_path__ + "static/media/googlePlay-ptBR.6583181e.png";